// extracted by mini-css-extract-plugin
export default {"container":"Question_container__dQdi8","title":"Question_title__JRpnf","btn":"Question_btn__AJTXs"};